import { Button, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { JRow, JTable, JTBody, JTHead, JvCaption, MakeMessageError } from "../../../../components/Components";
import { faDoorClosed, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import manifestoService from "../../../../services/ManifestoService";
import { rgx_numberOnly } from "../../../../utils/utils";
import auxService from "../../../../services/AuxService";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";

interface ModalIncluirCondutorProps {
    show: boolean;
    id: string;
    onHide: () => void;
    situacao: number;
}

interface IForm {
    nome: string;
    cpf: string;
}

const initialForm: IForm = {
    nome: '',
    cpf: ''
}

const initialFieldsError = {
    cpf: [],
    name: [],
}

const ModalIncluirCondutor: React.FC<ModalIncluirCondutorProps> = ({ show, id, onHide, situacao }) => {

    const [form, setForm] = useState<IForm>(initialForm);
    const [errors, setErrors] = useState(initialFieldsError);
    const [lista, setLista] = useState<any[]>([]);
    const formInclusaoRef = useRef<HTMLDivElement>(null);
    const btnIncluirRef = useRef<HTMLButtonElement>(null);
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [titleModal, setTitleModal] = useState<string>('Incluir Condutor');

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setErrors(prev => ({ ...prev, [name]: "" }));

        const transformers: Record<string, (val: string) => string> = {
            cpf: rgx_numberOnly,
        };

        const newValue = transformers[name] ? transformers[name](value) : value;

        setForm((prev) => ({
            ...prev,
            [name]: newValue
        }))
    }

    const handleIncluirCondutor = async () => {
        btnIncluirRef.current?.setAttribute('disabled', 'disabled');
        await manifestoService
            .incluirCondutor(id, form.nome, form.cpf)
            .then(res => {
                alertModal('Condutor incluído com sucesso.', "success");

                setLista([{
                    id: res.data.id,
                    nome: res.data.nome,
                    cpf: res.data.cpf
                }, ...lista]);

                setForm(initialForm);


            }).catch(error => {
                if (error.status === 400) {
                    alertModal(error.response.data.message, "danger");
                }
                else if (error.status === 422) {
                    setErrors(error.response.data)
                }
                else {
                    alertModal(error.response.data.message ?? 'Contacte o administrador', "danger");
                }
            })
        btnIncluirRef.current?.removeAttribute('disabled');
    }
    useEffect(() => {
        auxService.getListaCondutoresIncluidos(id).then(res => {
            setLista(res);
        })
            .catch(error => {
                console.log(error);
            })

        if (formInclusaoRef.current) {
            if (situacao === 2) {
                formInclusaoRef.current.classList.remove("d-none");
                setTitleModal('Incluir Condutor')
            } else {
                formInclusaoRef.current.classList.add("d-none");
                setTitleModal('Lista de condutores')
            }
        }

    }, []);
    return (<>
        <Modal show={show} onHide={() => {
            setForm(initialForm);
            onHide();
        }} size="lg" centered backdrop='static' >
            <Modal.Header closeButton className="bg-success-subtle border-2 border-success py-2">
                <Modal.Title className="h6">{titleModal}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="" >
                <div id="form-inclusao" className="" ref={formInclusaoRef}>

                    <JRow className="mb-2">
                        <Col sm={7}>
                            <Form.Group>

                                <Form.Label>Nome do Condutor</Form.Label>
                                <Form.Control name="nome" value={form.nome} maxLength={60}
                                    onChange={handleChange}
                                />
                                <MakeMessageError errors={errors} field="nome" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>

                                <Form.Label>CPF</Form.Label>
                                <InputGroup>
                                    <Form.Control name="cpf" value={form.cpf} onChange={handleChange}
                                        maxLength={11} />
                                    <Button variant="success" onClick={handleIncluirCondutor} ref={btnIncluirRef}>
                                        <FontAwesomeIcon icon={faPaperPlane} /> Incluir
                                    </Button>
                                </InputGroup>
                                <MakeMessageError errors={errors} field="cpf" />
                            </Form.Group>
                        </Col>

                    </JRow>
                    {/* <div className="mb-3 pb-2 h5 border-bottom border-2 border-success w-100" ></div> */}
                </div>

                <JTable className="caption-top mb-1 border border-2 border-success  table table-sm table-striped table-bordered">
                    <JvCaption className="text-center ps-2 fw-bold rounded-top-2 border-top border-start border-end  bg-success-subtle border-success border-2">Lista de condutor(es) incluídos no manifesto</JvCaption>

                    <JTHead>

                        <tr>
                            <th>CPF</th>
                            <th>NOME DO CONDUTOR</th>
                        </tr>
                    </JTHead>
                    <JTBody>
                        {lista.map((item: any) => (
                            <tr key={item.id}>
                                <td>{item.cpf}</td>
                                <td>{item.nome}</td>
                            </tr>
                        ))}
                    </JTBody>
                </JTable>

            </Modal.Body>

            <Modal.Footer className="py-1">

                <Button variant="secondary" onClick={() => {
                    setForm(initialForm);
                    onHide();
                }}>
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>

        </Modal>
        {ModalMessageEl}
    </>);
};

export default ModalIncluirCondutor;
